import React from 'react';
import { connectToStore } from '../../../store';
import styles from './UserDetails.module.scss';

function UserDetails() {
	return <div className={styles.userDetails}>User Details - Work in Progress</div>;
}

export default connectToStore(UserDetails);
